const WorkIcon = () => {
    return (
        <i className="fa-solid fa-briefcase"></i>
    )
}

export default WorkIcon;